module.exports = "https://trybtryb-legacy.web.app/img/oval-transparent-desktop.c90b9be0.svg";